import { render, staticRenderFns } from "./rateComparatorPizzas.vue?vue&type=template&id=0e620f42&scoped=true&lang=pug"
import script from "./rateComparatorPizzas.vue?vue&type=script&lang=js"
export * from "./rateComparatorPizzas.vue?vue&type=script&lang=js"
import style0 from "./rateComparatorPizzas.vue?vue&type=style&index=0&id=0e620f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e620f42",
  null
  
)

export default component.exports